import { useEffect, useRef, memo } from 'react';
import type { ReactNode } from 'react';

import parsers from '../../services/parsers';

interface RichContentProps {
  content: string;
  className?: string;
  component?: ReactNode;
  styles?: object;
  shouldZoomIntoImage?: boolean;
  shouldLockMediaContent?: boolean;
  accessibleVideoTitle?: string;
  expandableContentLabel?: string;
  projectId?: number | null;
  userId?: number | null;
  currentUserEmail?: string | null;
  translations?: {
    codioButtonLabel?: string;
  };
}

const RichContent = memo(
  ({
    content,
    className = '',
    component = 'div',
    styles = undefined,
    shouldZoomIntoImage = false,
    shouldLockMediaContent = false,
    accessibleVideoTitle = 'video',
    expandableContentLabel = undefined,
    projectId = null,
    userId = null,
    currentUserEmail = null,
    ...otherProps
  }: RichContentProps) => {
    const richContainerRef = useRef(null);
    const RichContainer = component;

    useEffect(() => {
      if (!richContainerRef) return;

      parsers.parse(richContainerRef.current, styles, { shouldLockMediaContent });
    });

    return (
      <RichContainer
        ref={richContainerRef}
        className={`${className}`}
        dangerouslySetInnerHTML={{ __html: content }}
        styles={styles}
        {...otherProps}
        data-shouldzoomintoimage={shouldZoomIntoImage ? 'true' : null}
        data-videotitle={accessibleVideoTitle}
        data-expandable-content-label={expandableContentLabel}
        data-current-user-id={userId}
        data-project-id={projectId}
        data-current-user-email={currentUserEmail}
      />
    );
  }
);

export default RichContent;
